import { render, staticRenderFns } from "./ProfileGestor.vue?vue&type=template&id=4a5a740a&scoped=true"
import script from "./ProfileGestor.vue?vue&type=script&lang=js"
export * from "./ProfileGestor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5a740a",
  null
  
)

export default component.exports